
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clobe/estimated-calculator",
      function () {
        return require("private-next-pages/clobe/estimated-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clobe/estimated-calculator"])
      });
    }
  